<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-6">
          <div class="row pb-4">
            <div class="col-md-12">
              <PlanMetrics
                :plan="plan"
                :site="site"
                :loading="loadingUsage || loadingAutoscale"
                :usage-metrics="usageMetrics"
                :autoscale-metrics="autoscaleMetrics"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row pb-4">
            <div class="col-md-12">
              <PlanLocation v-if="plan" :plan="plan" :plan-status="planStatus" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "@vue/composition-api";
import PlanLocation from "@/components/smart/cards/PlanLocation";
import PlanMetrics from "@/components/smart/cards/PlanMetrics";
import store from "@/store";

export default {
  name: "SharedHostSafeHarborStagingEnvironmentSettingsPage",
  components: { PlanMetrics, PlanLocation },
  setup() {
    const plan = computed(() => store.getters["plans/getItem"]);
    const planStatus = computed(() => store.getters["plans/getItemStatus"]);
    const site = computed(() => store.getters["devSites/getItem"]);
    const siteStatus = computed(() => store.getters["devSites/getItemStatus"]);

    const usageMetrics = ref({
      storageTotalGb: null,
      storageUsedGb: null,
      bandwidthUsedGb: null,
      bandwidthTotalGb: null,
    });

    const autoscaleMetrics = ref({
      concurrentUsers: null,
      totalConcurrentUsers: null,
      totalConcurrentUsersScaled: null,
      isScaled: null,
      enabled: false,
    });

    const loadingUsage = ref(true);
    const loadingAutoscale = ref(true);

    onMounted(() => {
      store.dispatch("plans/getItem", site.value.plan.id);
      // get usage metrics (bandwidth and storage)
      store
        .dispatch("sites/getUsageMetrics", site.value.id)
        .then((metrics) => {
          usageMetrics.value = metrics;
        })
        .finally(() => {
          loadingUsage.value = false;
        });

      // get autoscaling metrics (just concurrent users)
      // the max number of users (totalConcurrentUsersScaled) scales up or down depending on whether autoscaling is actively doing things)
      store
        .dispatch("sites/getAutoscaleMetrics", site.value.id)
        .then((metrics) => {
          autoscaleMetrics.value = metrics;
        })
        .finally(() => {
          loadingAutoscale.value = false;
        });
    });
    return {
      plan,
      planStatus,
      site,
      siteStatus,
      usageMetrics,
      autoscaleMetrics,
      loadingUsage,
      loadingAutoscale,
    };
  },
};
</script>
<style lang="scss" scoped></style>
